import { AppSyncError } from "./AppSyncError.js";

export function findExpectedAppSyncErrorMessage(
	error: unknown,
	expectedErrors: Record<string, string | ((error: Error) => string)> = {},
): string | undefined {
	if (error instanceof AppSyncError) {
		const [mainError] = error.errors;
		const expectedError = mainError?.errorType && expectedErrors[mainError.errorType];
		if (typeof expectedError === "string") {
			return expectedError;
		} else if (typeof expectedError === "function") {
			return expectedError(error);
		}
	}
	return undefined;
}
